import { UserIcon, HelpIcon } from 'components/Icon';

export const ICON_MAP = {
  USER: UserIcon,
  HELP: HelpIcon,
};

export const POSITIONS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
};

export const TYPES = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
  GLOBAL: 'global',
  LEVEL_1: 'level_1',
  LEVEL_2: 'level_2',
  LEVEL_3: 'level_3',
  MINI_NAV: 'mini_nav',
  BREADCRUMBS: 'breadcrumbs',
  BACK: 'back',
  SEARCH: 'search',
};
